<template>
    <div class="modal fade modal-sm" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"></h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body custom-label">
        Are you sure you want to delete this record?
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
        <button type="button" class="btn btn-danger btn-sm delete-button" @click="deleteRecord" data-bs-dismiss="modal">Delete Record</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    deleteRecord: {
      type: Function,
      required: true
    }
  },
  methods: {
    deleteRecord() {
      // Call the custom function passed from the parent
      this.deleteRecord();
    }
  }
}
</script>